import React from "react";
import "../styles.css";

type CoachMarkStepNineProps = {
  visible: boolean;
  onNext: () => void;
};

const CoachMarkStepNine = ({ visible, onNext }: CoachMarkStepNineProps) => {
  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay coachmark-overlay-centered"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step nine"
    >
      <div className="coachmark-step-nine-card">
        <div className="coachmark-step-nine-inner">
          <img
            src={require("../../assets/u4uOnb.png")}
            alt="U4U"
            className="coachmark-step-nine-logo"
          />
          <img
            src={require("../../assets/ic_housepledge.png")}
            alt="House pledge"
            className="coachmark-step-nine-title"
          />

          <div className="coachmark-step-nine-illustrations">
            <img
              src={require("../../assets/heart-lock 1.png")}
              alt="Heart lock"
              className="coachmark-step-nine-illustration"
            />
            <img
              src={require("../../assets/heart-lock 2.png")}
              alt="Heart lock icon"
              className="coachmark-step-nine-illustration"
            />
          </div>

          <div className="coachmark-step-nine-text">
            I'm committed to check in as often as I can, so over time I'll know
            myself better, what I want, and how to get where I want to be.
          </div>

          <button
            type="button"
            onClick={onNext}
            className="coachmark-step-nine-next"
            aria-label="Lets go"
          >
            <span>LET'S GO!!!</span>
            <img
              src={require("../../assets/arrow-left-coach.png")}
              alt=""
              aria-hidden="true"
              className="coachmark-step-nine-next-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepNine;